<template>
    <v-container fluid class="main-container d-block pa-0">
        <div class="container-form">
            <DeviceHeaderMenu v-if="controllerData" :room-data="controllerData.hotel_room" no-settings @back="back"/>
            <v-flex class="controller-name" xs12 v-if="controllerData">
                {{controllerData.name}}
                <span class="main-text green-text ml-2" v-if="controllerData.online">online</span>
                <span class="main-text red-text ml-2" v-else>offline</span>
            </v-flex>
            <v-flex xs12 px-10>
                <v-btn class="btn-light-grey main-text" @click="searchInterrupt" v-if="disabledJoinBtn">
                    Остановить поиск
                </v-btn>
                <v-btn class="btn-light-grey main-text" @click="joinDevice" v-else>
                    Поиск ZigBee устройств
                </v-btn>
            </v-flex>
            <v-flex xs12 v-if="disabledJoinBtn" class="timer">
                {{timer}}
            </v-flex>
            <v-layout class="devices-list mt-4" v-if="newDevices.length > 0" row>
                <v-flex
                    class="devices-list__device"
                    :class="{'devices-list__device__large': largeScreen}"
                    :xs4="!largeScreen"
                    :xs3="largeScreen"
                    v-for="(listColumn, indexColumn) in newList"
                    :key="`zigbeeColumn${indexColumn}`"
                >
                    <v-layout column>
                        <v-flex v-for="(zigbee, index) in listColumn" :key="`zigbee${index}`">
                            <ZigbeeDevice
                                :device="zigbee"
                                :controller="controllerId"
                                :first="indexColumn == 0"
                                :last="indexColumn == newList.length - 1"
                                :update="addDevice"
                                :updateDelete="deleteDevice"
                                canDelete
                            />
                        </v-flex>
                    </v-layout>
                </v-flex>
            </v-layout>
            <v-layout v-if="disabledJoinBtn" class="d-inline-flex align-center justify-center" column>
                <div>
                    <v-img class="connection-animate" height="42px" width="42px" :src="require('@/assets/icons/connection.png')"></v-img>
                </div>
                <div class="main-text mt-1"> Поиск... </div>
            </v-layout>
            <v-divider v-if="newDevices.length > 0" class="my-4"></v-divider>
            <v-layout class="devices-list mt-4" v-if="zigbeeList.length > 0" row>
                <v-flex
                    class="devices-list__device"
                    :class="{'devices-list__device__large': largeScreen}"
                    :xs4="!largeScreen"
                    :xs3="largeScreen"
                    v-for="(zigbeeColumn, indexColumn) in zigbeeList"
                    :key="`zigbeeColumn${indexColumn}`"
                >
                    <v-layout column>
                        <v-flex v-for="(zigbee, index) in zigbeeColumn" :key="`zigbee${index}`">
                            <ZigbeeDevice
                                :device="zigbee"
                                :controller="controllerId"
                                :first="indexColumn == 0"
                                :last="indexColumn == zigbeeList.length - 1"
                                :update="addDevice"
                                :updateDelete="deleteDevice"
                                canDelete
                            />
                        </v-flex>
                    </v-layout>
                </v-flex>
            </v-layout>
        </div>
        <ModalWaiting ref="modalWaiting" title="Загрузка данных"></ModalWaiting>
        <v-snackbar v-model="snackbar" :multi-line="true">
            Устройство отвязано!
            <template v-slot:action="{ attrs }">
                <v-btn
                    color="white"
                    text
                    v-bind="attrs"
                    @click="snackbar = false"
                >
                    Закрыть
                </v-btn>
            </template>
        </v-snackbar>
    </v-container>
</template>

<script>
import DeviceHeaderMenu from "@/components/DeviceHeaderMenu";
import ModalWaiting from "@/components/modals/ModalWaiting";
import ZigbeeDevice from "@/components/ZigbeeDevice";
import Centrifuge from "centrifuge";
import {eventBus} from "@/main";

export default {
    name: "ControllerPage",
    components: {ModalWaiting, DeviceHeaderMenu, ZigbeeDevice},
    data() {
        return {
            controllerId: null,
            disabledJoinBtn: false,
            controllerData: {},
            timer: null,
            show: false,
            windowWidth: window.innerWidth,
            snackbar: false,
            newDevices: [],
        };
    },
    created() {
        this.controllerId = this.$route.params.id;
        eventBus.$on("joining", this.updateTimeout);
        eventBus.$on("leave", this.openSnackbar);
        eventBus.$on("joined", this.addDevice);
        eventBus.$on("interviewing", this.addDevice);
    },
    beforeDestroy() {
        if (this.centrifuge) {
            this.centrifuge.disconnect();
        }
        eventBus.$off("joining", this.updateTimeout);
        window.removeEventListener('resize', this.onResize);
        eventBus.$off("leave", this.openSnackbar);
        eventBus.$off("joined", this.addDevice);
        eventBus.$off("interviewing", this.addDevice);
    },
    mounted() {
        if (this.controllerId) {
            this.getController();
        }
        this.$nextTick(() => {
            window.addEventListener('resize', this.onResize);
        });
    },
    computed: {
        largeScreen() {
            return this.windowWidth > 1440;
        },
        zigbeeList() {
            if (this.controllerData) {
                let zigbeeDevices = this.controllerData.zigbee_devices ? JSON.parse(JSON.stringify(this.controllerData.zigbee_devices)) : [];
                let divider = this.largeScreen ? 4 : this.windowWidth > 1151 ? 3 : this.windowWidth > 701 ? 2 : 1;
                let minLength = parseInt(zigbeeDevices.length / divider);
                let zigbeeArr = [];
                let slice = 0;
                for (let i = 0; i < divider; i++) {
                    if ((zigbeeDevices.length % divider) > i) {
                        zigbeeArr[i] = zigbeeDevices.slice(slice, slice + minLength + 1);
                        slice += minLength + 1;
                    } else {
                        zigbeeArr[i] = zigbeeDevices.slice(slice, slice + minLength);
                        slice += minLength;
                    }
                }
                return zigbeeArr;
            }
            return [];
        },
        newList() {
            if (this.newDevices) {
                let zigbeeDevices = this.newDevices ? JSON.parse(JSON.stringify(this.newDevices)) : [];
                let divider = this.largeScreen ? 4 : this.windowWidth > 1151 ? 3 : this.windowWidth > 701 ? 2 : 1;
                let minLength = parseInt(zigbeeDevices.length / divider);
                let zigbeeArr = [];
                let slice = 0;
                for (let i = 0; i < divider; i++) {
                    if ((zigbeeDevices.length % divider) > i) {
                        zigbeeArr[i] = zigbeeDevices.slice(slice, slice + minLength + 1);
                        slice += minLength + 1;
                    } else {
                        zigbeeArr[i] = zigbeeDevices.slice(slice, slice + minLength);
                        slice += minLength;
                    }
                }
                return zigbeeArr;
            }
            return [];
        },
    },
    methods: {
        getController() {
            this.$refs.modalWaiting.open();
            this.controllerData = {};
            this.$http.get('/controllers/hotel-admin/controller/' + this.controllerId + '/')
                .then((response) => {
                    this.controllerData = response.data;
                    if (this.controllerData && this.controllerData.hotel_room && !this.centrifuge) {
                        this.openWebSocket();
                    }
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    this.$refs.modalWaiting.close();
                });
        },
        joinDevice() {
            this.$http.put('/controllers/hotel-admin/joining-zigbee-device/' + this.controllerId + '/start/')
                .then((response) => {
                    this.disabledJoinBtn = true;
                    this.timer = this.formattedTimeout(response.data.timeout);
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        searchInterrupt() {
            this.$http.put('/controllers/hotel-admin/joining-zigbee-device/' + this.controllerId + '/stop/')
                .then(() => {
                    this.disabledJoinBtn = false;
                    this.timer = null;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        updateTimeout(data) {
            if (this.controllerId == data.controller) {
                this.timer = this.formattedTimeout(data.timeout);
                if (data.timeout == 1) {
                    this.disabledJoinBtn = false;
                } else if (data.timeout > 1) {
                    this.disabledJoinBtn = true;
                }
            }
        },
        formattedTimeout(val) {
            let minutes = 0;
            if (val >= 60) {
                minutes = Math.floor(val / 60);
            }
            minutes = parseInt(minutes) < 10 ? String(minutes).padStart(2, "0") : String(minutes);
            let seconds = val % 60;
            seconds = parseInt(seconds) < 10 ? String(seconds).padStart(2, "0") : String(seconds);
            return minutes + ":" + seconds;
        },
        openWebSocket() {
            this.centrifuge = new Centrifuge(process.env.VUE_APP_WS_API_URL, {
                retry: 1000,
                maxRetry: 2000,
            });
            const user_access_token = this.$store.state.accessToken;
            const room_pk = this.controllerData.hotel_room.uid;

            this.centrifuge.setConnectData({
                'user_access_token': user_access_token,
                'room_pk': room_pk,
            });
            let is_subscribe = false;

            this.centrifuge.on('connect', (ctx) => {
                console.log("connected", ctx);
                if (this.reconnect) {
                    this.reconnect = false;
                    eventBus.$emit("reconnectRoom");
                }
                let room_id = ctx.data.room_token;

                if (!is_subscribe) {
                    this.centrifuge.subscribe("room_update:room_" + room_id, function (ctx) {
                        if (ctx.data.update_type == "joining_zigbee_devices") {
                            eventBus.$emit("joining", {
                                controller: ctx.data.controller,
                                timeout: ctx.data.zigbee_device_joining_time,
                            });
                        } else if (ctx.data.update_type == "leave_zigbee_devices") {
                            eventBus.$emit("leave");
                        } else if (ctx.data.update_type == "joined_zigbee_devices") {
                            eventBus.$emit("interviewing", {
                                device: {
                                    ...ctx.data.zigbee_device,
                                    is_new: true,
                                },
                            });
                        } else if (ctx.data.update_type == "interview_zigbee_devices") {
                            eventBus.$emit("interviewing", {
                                device: {
                                    ...ctx.data.zigbee_device,
                                    is_new: true,
                                },
                            });
                        } else if (ctx.data.update_type == "announce_zigbee_devices") {
                            eventBus.$emit("joined", {
                                device: {
                                    ...ctx.data.zigbee_device,
                                    is_new: true,
                                },
                            });
                        }
                    });
                    is_subscribe = true;
                }
            });

            this.centrifuge.on('disconnect', (ctx) => {
                this.reconnect = true;
                console.log("disconnected", ctx);
            });
            this.centrifuge.connect();
        },
        deleteDevice(device) {
            if (this.controllerData.zigbee_devices) {
                let index = this.controllerData.zigbee_devices.map(zigbee => {
                    return zigbee.inner_number
                }).indexOf(device);
                if (index != -1) {
                    this.controllerData.zigbee_devices.splice(index, 1);
                } else if (this.newDevices) {
                    let index = this.newDevices.map(zigbee => {
                        return zigbee.inner_number
                    }).indexOf(device);
                    if (index != -1) {
                        this.newDevices.splice(index, 1);
                    }
                }
            }
        },
        addDevice(data) {
            let is_new = false;
            if (data.device.is_new) {
                is_new = true;
            }
            if (this.controllerData.zigbee_devices) {
                let index = this.controllerData.zigbee_devices.map(zigbee => {
                    return zigbee.inner_number
                }).indexOf(data.device.inner_number);
                if (index != -1) {
                    this.$set(this.controllerData.zigbee_devices, index, data.device);
                    is_new = false;
                } else if (this.newDevices) {
                    let index = this.newDevices.map(zigbee => {
                        return zigbee.inner_number
                    }).indexOf(data.device.inner_number);
                    if (index != -1) {
                        this.$set(this.newDevices, index, data.device);
                        is_new = false;
                    }
                }
            }
            if (is_new) {
                this.newDevices.unshift(data.device);
            }
        },
        openSnackbar() {
            this.snackbar = true;
            this.getController();
        },
        onResize() {
            this.windowWidth = window.innerWidth;
        },
        back() {
            if (this.controllerData && this.controllerData.hotel_room) {
                this.$router.push({name: "roompage", params: {id: this.controllerData.hotel_room.uid}});
            }
        },
    },
}
</script>

<style lang="scss" scoped>
.main-container {
    height: 100%;
    text-align: center;

    .container-form {
        width: 100%;
        display: inline-flex;
        justify-content: center;
        flex-direction: column;
        text-align: left;
    }
}

.controller-name {
    display: flex;
    justify-content: center;
    align-items: flex-end;
    font-weight: 500;
    font-size: 26px;
    line-height: 32px;
    color: #130F26;
    margin-bottom: 20px;
}

.btn-light-grey {
    min-height: 60px;
    height: 60px;
}

.timer {
    font-family: 'Digital';
    font-style: normal;
    font-weight: 600;
    font-size: 32px;
    line-height: 40px;
    color: #130F26;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 32px;
}

.connection-animate {
    animation: scale 1s infinite linear;
}
@keyframes scale {
    0% {
        transform: scaleX(-1);
    }
    50% {
        transform: scaleX(-1);
    }
    51% {
        transform: scaleX(1);
    }
    100% {
        transform: scaleX(1);
    }
}
</style>